import { isAtradiusRefused } from "../../utils/atradiusRefusal";
import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ClientAtradiusWarning({ cover, onClick }) {
  if (!isAtradiusRefused(cover)) return null;
  return <button type="button" onClick={onClick} title="Couverture Atradius refusée · Voir la couverture" className="inline-flex items-center gap-1.5 rounded-full border border-red-600 bg-red-600 px-2.5 py-1 text-xs font-semibold text-white hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-600"><AlertTriangle size={16} aria-hidden="true" />Atradius refusé</button>;
}
